export default "__VITE_ASSET__BGZNvqEb__"